import {createContext,useContext} from "react";
export const MonthGroupingContext=createContext<{enabled:boolean;byStore:boolean;setByStore:(value:boolean)=>void}|null>(null);
export const useMonthGrouping=()=>useContext(MonthGroupingContext);
